/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
import { Breakpoint, getMinBreakpointValue } from 'utils/mediaqueries';

import Media from 'react-media-universal';
import PropTypes from 'prop-types';
import React from 'react';
import { labels } from 'config/theme/breakpoints';

const Above = ({ breakpoint, render }) => (
    <Breakpoint.Consumer>
        {({ breakpointIndex }) => (
            <Media
                query={{ minWidth: getMinBreakpointValue(breakpoint) }}
                defaultMatches={breakpointIndex >= labels.indexOf(breakpoint)}
                render={render}
            />
        )}
    </Breakpoint.Consumer>
);

Above.propTypes = {
    breakpoint: PropTypes.oneOf(labels).isRequired,
    children: (props, propName, componentName) => {
        if (propName in props) {
            return new Error(`Using children in Above is deprecated. Use render prop instead.`);
        }
    },
    render: PropTypes.func.isRequired,
};

export default Above;
